import { styled } from '@mui/material';
import { Datagrid } from 'shared/react-admin/Datagrids';

export const DatagridStyled = styled(Datagrid)({
  '& th:last-child, & td:last-child': {
    width: '44px',
    textAlign: 'right',
  },
});
